import { render, staticRenderFns } from "./ReFioPadej.vue?vue&type=template&id=21b6418a&scoped=true"
import script from "./ReFioPadej.vue?vue&type=script&lang=js"
export * from "./ReFioPadej.vue?vue&type=script&lang=js"
import style0 from "./ReFioPadej.vue?vue&type=style&index=0&id=21b6418a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6418a",
  null
  
)

export default component.exports